import { Injectable } from '@angular/core';
import { gql, Query } from 'apollo-angular';

import { Query as RootQuery } from 'graphql/models/generated';

export const FAVORITES_QUERY = gql`
  query favorites($modelOrProductId: String!) {
    favorites(modelOrProductId: $modelOrProductId) {
      documentId
      lineId
      title
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class FavoritesQuery extends Query<RootQuery> {
  document = FAVORITES_QUERY;
}
